export default [
  "/",
  "/team-wiki",
];